import { Skeleton } from '@mui/material';

const cardPlaceholders = Array.from({ length: 2 });

export function FinishesGroupSkeleton() {
  return (
    <div className="flex flex-col gap-1 w-full">
      <div className="flex flex-row justify-between items-center w-full">
        <Skeleton variant="text" width={140} height={30} />
        <Skeleton variant="text" width={80} height={30} />
      </div>
      <div className="flex flex-wrap" style={{ minHeight: '180px' }}>
        {cardPlaceholders.map((_, index) => (
          <div key={index} style={cardStyle} className="flex flex-col gap-2">
            <Skeleton
              variant="rectangular"
              height={100}
              sx={{ borderRadius: '16px', aspectRatio: '1 / 1' }}
            />
            <Skeleton
              variant="rectangular"
              height={30}
              sx={{ borderRadius: '16px' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

const cardStyle = {
  width: '100px',
  padding: '5px',
};
